import React from 'react';
import { Radio } from '@base-ui/react/radio';
import { RadioGroup } from '@base-ui/react/radio-group';

type CampoRadioProps = {
  id: string;
  type?: 'radio' | 'checkbox';
  name?: string;
  label: string;
  checked: boolean;
  value?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  inline?: boolean;
};

const radioStyle: React.CSSProperties = {
  WebkitAppearance: 'none',
  appearance: 'none',
  width: '16px',
  height: '16px',
  border: '1.5px solid var(--tc-color-gray-400)',
  borderRadius: '50%',
  backgroundColor: 'var(--tc-color-gray-200)',
  display: 'grid',
  placeContent: 'center',
  cursor: 'pointer',
  transition: 'border-color 120ms cubic-bezier(0.2, 0, 0, 1)',
  flexShrink: 0,
};

const CampoRadio = (props: CampoRadioProps) => {
  return (
    <div style={{ width: '100%' }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: props.disabled ? 'not-allowed' : 'pointer' }}>
        <Radio.Root
          id={props.id}
          value={props.value}
          disabled={props.disabled}
          style={radioStyle}
        >
          <Radio.Indicator
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: 'var(--tc-color-primary)',
            }}
          />
        </Radio.Root>
        <span style={{ fontSize: '14px', color: props.disabled ? 'var(--tc-color-gray-500)' : 'var(--fg-1)' }}>
          {props.label}
        </span>
      </label>
    </div>
  );
};

export default CampoRadio;
